export default "__VITE_ASSET__BWIvwJGi__"